import React, { useState } from "react";

interface TenantLogoProps {
  logo: React.FC<React.SVGProps<SVGSVGElement>> | string | undefined;
  alt?: string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

/**
 * Renders a tenant brand mark, transparently handling every form of `logo`:
 * a React SVG component (from the static registry), a URL string (e.g. a
 * backend-provided logo), or undefined (renders nothing — e.g. TenantBrand.logo
 * while its branding fetch is loading/erroring). A URL that fails to load (e.g.
 * an expired SAS URL) also renders nothing. Callers pass `logo` from useTenant.
 */
export const TenantLogo: React.FC<TenantLogoProps> = ({ logo, alt = "", className, style, onClick }) => {
  const [failed, setFailed] = useState(false);

  if (!logo || failed) return null;
  if (typeof logo === "string") {
    return <img src={logo} alt={alt} className={className} style={style} onClick={onClick} onError={() => setFailed(true)} />;
  }
  const LogoComponent = logo;
  return <LogoComponent className={className} style={style} onClick={onClick} />;
};
